export interface ITeam {
  uuid?: string;
  name: string;
  roomPlayers: number;
  /** Venue wall clock, `YYYY-MM-DD HH:mm:ss`, as the backend stores `startDateTimeTz`. */
  startDateTime: string;
  endDateTime: string;
  nfcTag: string;
  paired: boolean;
  /** Order token values of the team's tickets, scanned once the team is paired. */
  tokens: string[];
  teamLevel: number;
}

export interface ITeamSetting {
  categoryId: number;
  maxParticipants: number;
  countedPsp: number[];
}

export enum BookingTeamsStatus {
  NotStarted = 0,
  Completed = 1,
  InProgress = 2,
}

export enum TeamLevel {
  EASY = 1,
  MEDIUM = 2,
  HARD = 3,
}
